import * as React from "react"
// @ts-ignore
import {saSubtitleContainer, subtitle} from './saSubtitle.module.css'
import { saInterfacesTitle } from "../saTypes"


export const SaSubtitle: React.FC<saInterfacesTitle> = ({title,classes}) =>  {


  return (
    <div className={ saSubtitleContainer }>
      <div
        className={ subtitle + ' ' + (classes ?  classes : '') }
        dangerouslySetInnerHTML={{__html: title}}
      />
    </div>
  )

}
